import React, { useEffect, useRef } from "react";
import { getCookie } from "@/utils/common";
import dynamic from "next/dynamic";
const UseCase = dynamic(() => import("./use-case/use-case"),{ssr: true});
const UseCaseDetails = dynamic(() => import("./user-case-details"),{ssr: true});
const HocHead = dynamic(() => import("@/Components/HigherOrderComponent/HocHead"),{ssr: true});

type UseCasePageProps = {
  slug: string;
  data: any;
};

const UseCasePage: React.FC<UseCasePageProps> = ({ data }) => {
  // const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const modalOpenTimeRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const attributes = data?.data[0]?.attributes;
  const seo = attributes?.seo;
  const blocks = attributes?.blocks;

  useEffect(() => {
    const subscriptionModalClosedOnce = getCookie(
      "SubscriptionModalClosedOnce"
    );
    if (!subscriptionModalClosedOnce) {
      if (modalOpenTimeRef.current) {
        clearTimeout(modalOpenTimeRef.current);
      }

      // modalOpenTimeRef.current = setTimeout(() => {setShowSubscribeModal(true);}, 25000);
    }

    return () => {
      if (modalOpenTimeRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        clearTimeout(modalOpenTimeRef.current);
      }
    };
  }, []);

  const SwitchCase = ({ slug }: { slug: string }) => {
    switch (slug) {
      case "use-cases":
        return <UseCase blocks={blocks} slug={slug} />;
      default:
        return <UseCaseDetails data={attributes} />;
    }
  };

  return (
    <>
      {seo && <HocHead seo={seo} />}
      {attributes?.slug && <SwitchCase slug={attributes.slug} />}
    </>
  );
};

export default UseCasePage;
